import { Box } from '@mui/material';
import { getTheme, spacingSizeMap } from '@insights-ltd/design-library/themes';
import {
  Link,
  SvgShareExternalLinkCustom,
  TextV2,
} from '@insights-ltd/design-library/components';
import { INSIGHTS_DEVELOPERS_URL } from 'variables';
import { useTranslation } from 'react-i18next';

const ApiProfileInfoLink = () => {
  const { t } = useTranslation();
  const localTheme = getTheme();
  return (
    <Box
      sx={{
        pt: (theme) => theme.spacing(spacingSizeMap.XS),
      }}
    >
      <Link id="api-info-link" href={INSIGHTS_DEVELOPERS_URL} target="_blank">
        <SvgShareExternalLinkCustom
          height={14}
          stroke={localTheme.brandColours.blue}
          strokeWidth={2}
        />
        <TextV2 variant="button" color="primary" sx={{ marginLeft: 0.5 }}>
          {t('ui.event-management.profiles.api-profile-link-text')}
        </TextV2>
      </Link>
    </Box>
  );
};

export default ApiProfileInfoLink;
